/* eslint-disable */
export enum NotificationStatus {
  READ = 'read',
  UNREAD = 'unread',
}

export enum NotificationGroups {
  PLANNED_MAINTENANCE = 'Planned Maintenance',
  INCIDENTS = 'Incidents',
  DCIM_ALERTS = 'DCIM Alerts',
  SERVICE_TICKETS = 'Service Tickets',
}

export enum SubGroups {
  Remote_Hands = 'Remote Hands',
  Deliveries = 'Deliveries',
  Removals = 'Removals',
  Facility_Access = 'Facility Access',
  Trouble_Ticket = 'Trouble Ticket',
  Customer_Care = 'Customer Care',
  FacilityAccessVisitorAccess = 'FacilityAccessVisitorAccess',
  FacilityAccessPermanentBadge = 'FacilityAccessPermanentBadge',
  FacilityAccessOspAccess = 'FacilityAccessOspAccess',
  FacilityAccessPopPoeAccess = 'FacilityAccessPopPoeAccess',
}

export enum ApiCallState {
  LOADING = 'Loading',
  ERROR = 'Error',
  SUCCESS = 'Success',
}

export const DefaultDateFormat = 'yyyy-MM-dd';

export const DefaultTimeFormat = 'HH:mm:ss';

export const DefaultDisplayDays = 30;

export const DefaultDateTimeFormat = 'yyyy-MM-dd HH:mm:ss';
